import React from 'react';
import { useState, useEffect } from "react";
import {Dropdown, Card} from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import JasonFile from "./formLangfields.json";
import AddNewScheme from "./addNewScheme.jsx";
import QueryReletedScheme from "./queryReletedScheme.jsx";
import ViewAllScheme from "./viewAllScheme.jsx";

function AddQuery(props) {
  const navigate = useNavigate();
  const [newLabel, SetNewLabel] = useState(1);
  const {langCode,setLangCode} = {...props}
  useEffect(() => {
		let selectedLang = localStorage.getItem("selectedLang");
		setLangCode(selectedLang);
    let isLogin = localStorage.getItem("isLogin");
    if(isLogin != 'true'){
      navigate("/govtofindiascheme");
    }
  }, []);

  return (
    <>
      <div className='container mt-4'> 
          <Dropdown className='text-end'>
            <Dropdown.Toggle className='selectmenu text-start p-relative' variant="success">{JasonFile[0][langCode]}</Dropdown.Toggle>
            <Dropdown.Menu>
              {Object.entries(JasonFile[0]).map((res, i) => {
                return (
                  <Dropdown.Item value={res[0]} onClick={(e) => {setLangCode(res[0]); localStorage.setItem('selectedLang', res[0]); }} key={i}>{res[1]}</Dropdown.Item>
                )}
              )}
            </Dropdown.Menu>
          </Dropdown>
          <Card className='cardbg p-4 mt-3'>
            <Card.Body>
              <ul className='d-flex justify-content-start tablist'>
                {newLabel == 1 ? <>
                  <li className='active'>
                    <Link onClick={() => SetNewLabel(1)}>{JasonFile[1][langCode]}</Link>
                  </li>
                  <li>
                    <Link onClick={() => SetNewLabel(2)}>{JasonFile[2][langCode]}</Link>
                  </li>
                  <li>
                    <Link onClick={() => SetNewLabel(3)}>{JasonFile[3][langCode]}</Link>
                  </li>
                </> : ""}
                {newLabel == 2 ? <>
                  <li>
                    <Link onClick={() => SetNewLabel(1)}>{JasonFile[1][langCode]}</Link>
                  </li>
                  <li className='active'>
                    <Link onClick={() => SetNewLabel(2)}>{JasonFile[2][langCode]}</Link>
                  </li>
                  <li>
                    <Link onClick={() => SetNewLabel(3)}>{JasonFile[3][langCode]}</Link>
                  </li>
                </> : ""}
                {newLabel == 3 ? <>
                  <li>
                    <Link onClick={() => SetNewLabel(1)}>{JasonFile[1][langCode]}</Link>
                  </li>
                  <li>
                    <Link onClick={() => SetNewLabel(2)}>{JasonFile[2][langCode]}</Link>
                  </li>
                  <li className='active'>
                    <Link onClick={() => SetNewLabel(3)}>{JasonFile[3][langCode]}</Link>
                  </li>
                </> : ""}
                
              </ul>
              
              {newLabel === 1 ? <>
                <AddNewScheme langCode={langCode}/>
              </>:<></>}
            
              {newLabel === 2 ? <>
                <QueryReletedScheme langCode={langCode}/>
              </>:<></>}

              {newLabel === 3 ? <>
                <ViewAllScheme langCode={langCode}/>
              </>:<></>}
            </Card.Body>
          </Card>
        </div>
    </>
  )
}

export default AddQuery;

